import React from "react";
import Page from "Pages/_Layouts/DefaultInternal";
import useGetMetadata from "customHooks/useGetMetadata";
import { useTranslation } from "react-i18next";
import Loading from "customHooks/useCompleoReactHookForm/helpers/Loading";
import FormClassic from "customHooks/useCompleoReactHookForm/components/FormClassic";
import { useApi } from "customHooks/useApi";
import { useCancelButtonForm } from "customHooks/useCancelButtonForm";
import useValuesFromSource from "customHooks/useValuesFromSource";
import { getHandleWorkflowSubmit } from "./jobApprovalWorkflowPostHelper";
import useCompleoReactHookForm, {
    useCompleoReactHookFormGetMainData
} from "customHooks/useCompleoReactHookForm";
import CustomComponents from "./components/JobApprovalWorkflowCustomComponents";
import { useJobApprovalCustomLists } from "./utils/useJobApprovalCustomLists";
import { useJobApprovalFieldsToHide } from "./utils/useJobApprovalFieldsToHide";

const JobApprovalWorkflowNew = (props: any) => {
    const cancelFunction = useCancelButtonForm("/jobapprovalworkflow/list");
    const moduleName = "JOBAPPROVALWORKFLOWNEW";
    const [t, i18n, readyTranslation] = useTranslation(moduleName, {
        useSuspense: false
    });
    const postAddress = `/jobapprovalworkflow/new`;
    const [listDefinition, readyLists] = useJobApprovalCustomLists(t);

    const [addWorkflowReturn, addWorkflow] = useApi(postAddress, "post");
    const [metadata] = useGetMetadata(moduleName);
    const [valuesFromSource] = useValuesFromSource(metadata, true, {});
    valuesFromSource.deleted = false;
    valuesFromSource.default = false;
    valuesFromSource.selectionType = { value: "all" }; // Default selection type
    const ready = readyTranslation && metadata.status === "success";
    const handleSubmit = getHandleWorkflowSubmit(addWorkflow);
    const reactHookFormMethods = useCompleoReactHookFormGetMainData({
        t,
        ready: ready,
        i18nV: i18n,
        metadadosRetorno: metadata,
        valuesFromSource: valuesFromSource
    });
    const { watch } = reactHookFormMethods.reactHookFormMethods;
    const fieldsToHide = useJobApprovalFieldsToHide(watch);
    const [formCompleo, finished] = useCompleoReactHookForm({
        t: t,
        ready: readyTranslation && metadata.status === "success",
        i18nV: i18n,
        postMethod: handleSubmit,
        postReturn: addWorkflowReturn,
        redirectAddress: "/jobapprovalworkflow/list",
        FormType: FormClassic,
        metadadosRetorno: metadata,
        valuesFromSource: valuesFromSource,
        CustomComponents: CustomComponents,
        secondaryButtonFunction: cancelFunction,
        customLists: listDefinition,
        fieldsToHide: fieldsToHide,
        reactHookFormMethods: reactHookFormMethods
    });

    let compRetorno: boolean | JSX.Element;
    compRetorno = <Loading />;

    if (finished && readyTranslation && readyLists) {
        compRetorno = formCompleo;
        return (
            <Page
                featureName={t("a_FeatureName")}
                featureMainDescription={t("a_FeatureMainDescription")}
                maxWidth="md"
            >
                {compRetorno}
            </Page>
        );
    } else {
        return <Page>{compRetorno}</Page>;
    }
};

export default JobApprovalWorkflowNew;
